import { render, staticRenderFns } from "./iconQuestionAnswer.vue?vue&type=template&id=40faf15a"
import script from "./iconQuestionAnswer.vue?vue&type=script&lang=js"
export * from "./iconQuestionAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports